import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import HinhanhPageApi from './HinhanhPageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';
import { useSearchParams } from 'react-router-dom';
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');

function HinhanhPageDetail() {
  const [data, setData] = useState([]);
  const [danhmuc, setDanhmuc] = useState([]);
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('postId');

  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleImageClick = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const showNextImage = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex < data.length - 1 ? prevIndex + 1 : 0
    );
  };

  const showPrevImage = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.length - 1
    );
  };

  const modalStyles = {
    modal: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modalContent: {
      position: "relative",
      maxWidth: "80%",
      maxHeight: "80%",
    },
    modalImage: {
      width: "100%",
      height: "auto",
      borderRadius: "8px",
    },
    close: {
      position: "absolute",
      top: "10px",
      right: "10px",
      fontSize: "30px",
      fontWeight: "bold",
      color: "white",
      cursor: "pointer",
    },
    button: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "24px",
      fontWeight: "bold",
      color: "white",
      background: "none",
      border: "none",
      cursor: "pointer",
      zIndex: 1001,
    },
    prev: {
      backgroundColor: "black",
      borderRadius: "5px",
      left: "10px",
    },
    next: {
      backgroundColor: "black",
      borderRadius: "5px",
      right: "10px",
    },
  };

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });

    HinhanhPageApi.getAllType().then((data) => {
      setDanhmuc(data); // Update state with the resolved data
    }).catch((error) => {
      console.error("Failed to fetch data:", error); // Handle errors
    });

    HinhanhPageApi.getChiTietHinhAnh(postId).then((data) => {
      setData(data); // Update state with the resolved data
    })

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row">
            <Menu />
            <div className="col-md-9 col-sm-9 col-xs-12">
              <div id="gallery">
                {data.map((item, index) => (
                  <a
                    key={index}
                    className="fancybox-thumb"
                    rel="fancybox-thumb"
                    onClick={() => handleImageClick(index)}
                    title=""
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={FILE_URL + item.URL}
                      alt={`Image ${index + 1}`}
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                ))}
              </div>
              {selectedIndex !== null && (
                <div style={modalStyles.modal} onClick={closeModal}>
                  <div
                    style={modalStyles.modalContent}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span style={modalStyles.close} onClick={closeModal}>
                      &times;
                    </span>
                    <button
                      style={{ ...modalStyles.button, ...modalStyles.prev }}
                      onClick={showPrevImage}
                    >
                      &#8249;
                    </button>
                    <img
                      src={FILE_URL + data[selectedIndex].URL}
                      alt="Selected"
                      style={modalStyles.modalImage}
                    />
                    <button
                      style={{ ...modalStyles.button, ...modalStyles.next }}
                      onClick={showNextImage}
                    >
                      &#8250;
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 homeThongBao none-padding-left">
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC HÌNH ẢNH</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      {danhmuc?.map((item, index) => (
                        <li>
                          <a href={`/hinh-anh?title=${item.Name}&catId=${item.Id}`}>
                            <i className="fa fa-angle-right" /> {item.Name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="row" data-wow-delay="0.4s">
                  <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                    <a className="playlistWidget" href="/danh-sach-playlist/1">
                      <img src={require("./Theme/img/show_playlist.png")} />
                    </a>
                  </div>
                </div>
                <div className="homestats">
                  <h5 className="tittleHome">LIÊN KẾT</h5>
                  <ul>
                    <li>
                      <i className="fa fa-facebook" />
                      <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                    </li>
                    <li>
                      <i className="fa fa-youtube" />
                      <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>

      <footer>
        <div className="container">
          <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default HinhanhPageDetail;
